<template>
  <div>
    <div class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <div class="col-4 text-left ">
        <v-btn v-if="type === 1" :to="{path:'NewsesList',query:{isOnline:isOnline}}" small text>
          <span class="primary-text ml-2 pointer">MORE</span> <i
            class="fa-solid fa-arrow-left fa-lg pointer"></i>
        </v-btn>
        <v-btn v-else :to="{path:'ReviewsList',query:{isOnline:isOnline}}" small text>
          <span class="primary-text ml-2 pointer">MORE</span> <i
            class="fa-solid fa-arrow-left fa-lg pointer"></i>
        </v-btn>
      </div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-4 text-center pl-1">
        <v-skeleton-loader
            class="mx-auto"
            type="image"
        ></v-skeleton-loader>
      </div><div class="col-4 text-center pr-1">
        <v-skeleton-loader
            class="mx-auto"
            type="image"
        ></v-skeleton-loader>
      </div><div class="col-4 text-center pr-1">
        <v-skeleton-loader
            class="mx-auto"
            type="image"
        ></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">

      <div class="col-12" dir="ltr">
        <carousel
            v-if="items.length >0"
            :autoplay="false"
            :autoplayTimeout="7000"
            :dots="false"
            :margin="12"
            :nav="false"
            :responsive="{0:{items:3},600:{items:4},771:{items:3},1200:{items:4},}"
            :rtl="true">
          <router-link v-for="item in items" :key="item.ExtraExtensionID"
                       :to="{path:'ContentsDetail',query:{ExtraExtensionID:item.ExtraExtensionID}}" class="d-block" dir="rtl">
            <v-img :src="$replaceHttps(item.FileUrl)" aspect-ratio="1" class="rounded-lg">
            </v-img>
            <div class="text-center text-truncate mt-2">{{ item.Name }}</div>
          </router-link>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "ContentsCarousel",
  props: ['items', 'title', 'dataLoading', 'type', 'isOnline'],
  components: {
    carousel,
  },
  data: () => ({}),
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    }
  }
}
</script>

<style scoped>

</style>
